module.exports = __webpack_public_path__ + "img/20210906-1630898505838539.127ff648.jpg";